// ABOUTME: Segmented coverage meter of functional groups, doubling as the group filter
// ABOUTME: Signature element of the interviews list — encodes listening-tour coverage across the taxonomy

interface CoverageStripProps {
  /** Full group taxonomy (from persona definitions), so empty groups are visible */
  groups: string[]
  /** interview count per group */
  counts: Record<string, number>
  /** total interviews INCLUDING ones with no group — group counts alone undercount */
  total: number
  activeGroup: string | null
  onSelect: (group: string | null) => void
}

export function CoverageStrip({ groups, counts, total, activeGroup, onSelect }: CoverageStripProps) {
  const covered = groups.filter((g) => (counts[g] ?? 0) > 0)

  return (
    <div>
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
        Coverage — {total} interview{total === 1 ? '' : 's'} across {covered.length} of {groups.length} groups
      </p>
      <div className="flex flex-wrap gap-1.5" role="group" aria-label="Filter interviews by functional group">
        {groups.map((group) => {
          const count = counts[group] ?? 0
          const isActive = activeGroup === group
          const isEmpty = count === 0
          return (
            <button
              key={group}
              onClick={() => onSelect(isActive ? null : group)}
              aria-pressed={isActive}
              aria-label={`${group} — ${count} interview${count === 1 ? '' : 's'}. Filter.`}
              title={group}
              /* min-width keeps low-count segments clickable; width grows with share of interviews */
              style={{ flexGrow: Math.max(count, 0.25) }}
              className={`min-w-[2.5rem] px-2 py-1.5 rounded text-xs truncate text-center border transition-colors ${
                isActive
                  ? 'bg-alx-green/30 text-alx-blue border-alx-blue font-semibold'
                  : isEmpty
                    ? 'bg-white text-gray-400 border-dashed border-gray-300 hover:border-gray-400 font-medium'
                    : 'bg-alx-green/10 text-alx-blue border-alx-green/30 hover:bg-alx-green/20 font-medium'
              }`}
            >
              {group}
              <span className={`ml-1 font-semibold ${isEmpty ? 'text-gray-400' : 'text-alx-blue'}`}>
                {count}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
